// Shared by every agent surface, safely even with several mounted at once (the
// dock is hidden rather than unmounted): containerId is not part of the payload,
// so they all build an identical object.
var lastFullContext = {};
export function setLastFullContext(context) {
  lastFullContext = context;
}
export function getLastFullContext() {
  return lastFullContext;
}